import { CreateRescheduleRequestInput } from "@/domain/dtos/inputs/CreateRescheduleRequestInput";
import { z } from "zod";

export const CreateRescheduleRequestInputSchema: z.ZodType<CreateRescheduleRequestInput> =
  z.object({
    appointment_id: z.number().int().positive(),
    new_date: z.string(),
  });
